<template>
  <section class="avanced-filter-activetime-by-type">
    <div class="avanced-filter-activetime-by-type__container">
      <div class="avanced-filter-activetime-by-type__container__cont-select">
        <div class="avanced-filter-activetime-by-type__container__cont-select__label">
          Temporalidad:
        </div>
        <div class="avanced-filter-activetime-by-type__container__cont-select__selector">
          <BField position="is-centered" type="is-info" class="select-statistics">
            <BSelect :value="1" placeholder="Seleccione" expanded>
              <option :key="1" :value="1">Acumulado</option>
            </BSelect>
          </BField>
        </div>
      </div>
      <div class="avanced-filter-activetime-by-type__container__cont-buttons">
        <div class="avanced-filter-activetime-by-type__container__cont-buttons__label">
          Jugando de:
        </div>
        <div class="avanced-filter-activetime-by-type__container__cont-buttons__buttons-local">
          <button class="active">
            Local
          </button>
          <button class="active">
            Visitante
          </button>
        </div>
      </div>
      <div class="avanced-filter-activetime-by-type__container__cont-buttons">
        <div class="avanced-filter-activetime-by-type__container__cont-buttons__label">
          1er Tiempo:
        </div>
        <div class="avanced-filter-activetime-by-type__container__cont-buttons__buttons">
          <button class="active">
            0 - 15
          </button>
          <button class="active">
            16 - 30
          </button>
          <button class="active">
            31 - 45
          </button>
        </div>
      </div>
      <div class="avanced-filter-activetime-by-type__container__cont-buttons">
        <div class="avanced-filter-activetime-by-type__container__cont-buttons__label">
          2do Tiempo:
        </div>
        <div class="avanced-filter-activetime-by-type__container__cont-buttons__buttons">
          <button class="active">
            46 - 60
          </button>
          <button class="active">
            61 - 75
          </button>
          <button class="active">
            76 - 90
          </button>
        </div>
      </div>
      <div class="avanced-filter-activetime-by-type__container__cont-radio">
        <div class="avanced-filter-activetime-by-type__container__cont-radio__label">
          Resultado:
        </div>
        <div class="avanced-filter-activetime-by-type__container__cont-radio__radios">
          <BRadio class="radio-switch-advanced-filter-activetime" name="name" native-value="Ganados" type="is-info">
            Ganados
          </BRadio>
          <BRadio class="radio-switch-advanced-filter-activetime" name="name" native-value="Empatados" type="is-info">
            Empatados
          </BRadio>
          <BRadio class="radio-switch-advanced-filter-activetime" name="name" native-value="Perdidos" type="is-info">
            Perdidos
          </BRadio>
        </div>
      </div>
      <div class="buttom-filter" @click="showEmit(false)">Filtrar</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AvancedFilterActiveTimeByType',
  components: {},
  computed: {},
  data() {
    return {};
  },
  methods: {
    showEmit(flag) {
      this.$emit('show', flag);
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.buttom-filter {
  border-radius: 6px;
  background-color: #52a0fc;
  height: 40px;
  width: 100%;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 40px;
  letter-spacing: -0.44px;
  text-align: center;
  color: #fff;
  font-family: 'Avenir-Demi';
  margin-top: 61px;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
}
.radio-switch-advanced-filter-activetime {
  display: inline-flex;
  font-size: 11px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: -0.22px;
  text-align: left;
  color: #132839;
}
.avanced-filter-activetime-by-type {
  width: 100%;
  height: 402px;
  // background: red;
  &__container {
    width: 83.77%;
    height: 382px;
    display: inline-block;
    // background: green;
    margin: 0 auto;
    margin-top: 10px;
    &__cont-select {
      width: 100%;
      height: auto;
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
        font-family: 'Roboto-Medium';
      }
    }
    &__cont-radio {
      width: 100%;
      height: auto;
      margin-top: 7px;
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
        font-family: 'Roboto-Medium';
      }
      &__radios {
        width: 100%;
        height: 36px;
        border-radius: 5px;
        border: solid 1px #cfd3dc;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        height: 36px;
      }
    }
    &__cont-buttons {
      width: 100%;
      height: auto;
      margin-top: 7px;
      &__label {
        width: 100%;
        height: 20px;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: left;
        color: #95a3ae;
        font-family: 'Roboto-Medium';
      }
      &__buttons-local {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        height: 30px;
        background: rgb(255, 251, 18);

        button {
          border: solid 1px #b0d546;
          outline: none;
          height: 31px;
          width: 100%;
          font-family: 'Avenir-DemiCond';
          font-size: 15px;
          letter-spacing: -0.03px;
          text-align: center;
          line-height: 29px;
          color: #132839;
          cursor: pointer;
          transition: all 0.5s ease;
          &:first-child {
            border-radius: 4px 0px 0px 4px;
          }
          &:last-child {
            border-radius: 0px 4px 4px 0px;
          }
        }
        button.active {
          background: #cbee6b;
        }
      }
      &__buttons {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        height: 30px;
        background: rgb(255, 251, 18);
        button {
          border: solid 1px #b0d546;
          outline: none;
          height: 30px;
          font-family: 'Avenir-DemiCond';
          font-size: 15px;
          letter-spacing: -0.03px;
          text-align: center;
          color: #132839;
          cursor: pointer;
          transition: all 0.5s ease;

          &:first-child {
            border-radius: 4px 0px 0px 4px;
          }
          &:last-child {
            border-radius: 0px 4px 4px 0px;
          }
          @media screen and (max-width: 1033px) {
            font-size: 11px;
          }
          @media screen and (max-width: 1000px) {
            font-size: 12px;
          }
        }
        button.active {
          background: #cbee6b;
        }
      }
    }
  }
}
</style>
